import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../../service/udnick';

export const alterarBlacklist = {
  alterarBlacklist: (
    ativo: boolean,
    obs: string | null,
    codMotorista?: number,
    codVeiculo?: number
  ): Promise<AxiosResponse> =>
    UDNICK.callService('alteraBlacklist', { ativo, obs, codMotorista, codVeiculo }),
};
